// src/pages/admin/FraudDetail.jsx
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { adminFraudApi } from '../../api/services'
import { Card, CardHeader, CardBody, PageSpinner, StatusBadge, Badge } from '../../components/common/ui'

export default function FraudDetail() {
  const { userId } = useParams()
  const { data, isLoading } = useQuery({ queryKey: ['admin-fraud-user', userId], queryFn: () => adminFraudApi.show(userId) })
  if (isLoading) return <PageSpinner />
  const { user, flags = [], risk_score, recent_orders = [] } = data?.data?.data || {}

  return (
    <div className="max-w-2xl">
      <h1 className="text-xl font-display font-bold mb-2">{user?.name}</h1>
      <p className="text-muted text-sm mb-6">{user?.email}</p>
      <div className="grid sm:grid-cols-3 gap-4 mb-6">
        <div className="bg-white border border-border rounded-xl p-4 text-center"><p className="text-3xl font-bold text-pink">{risk_score ?? 0}</p><p className="text-xs text-muted">Risk Score</p></div>
        <div className="bg-white border border-border rounded-xl p-4 text-center"><p className="text-3xl font-bold">{flags.length}</p><p className="text-xs text-muted">Total Flags</p></div>
        <div className="bg-white border border-border rounded-xl p-4 text-center"><p className="text-3xl font-bold">{recent_orders.length}</p><p className="text-xs text-muted">Recent Orders</p></div>
      </div>
      <Card className="mb-4">
        <CardHeader><span className="font-bold text-sm">Fraud Flags</span></CardHeader>
        <CardBody className="p-0">
          {flags.map(f => (
            <div key={f.id} className="flex items-center justify-between px-5 py-3 border-b border-border last:border-b-0">
              <div><p className="text-sm font-medium">{f.rule}</p><p className="text-xs text-muted">{new Date(f.created_at).toLocaleDateString('en-IN')}</p></div>
              <div className="flex gap-2"><Badge variant={f.severity === 'high' || f.severity === 'critical' ? 'red' : 'yellow'}>{f.severity}</Badge><StatusBadge status={f.status} /></div>
            </div>
          ))}
          {flags.length === 0 && <p className="text-sm text-muted text-center py-6">No flags.</p>}
        </CardBody>
      </Card>
    </div>
  )
}
